import { NonFunctionalPreviewField } from "./NonFunctionPreview";
export const GPSPreview = ({
  type,
  value,
  rowGuid,
  ...entry
}) => {
  return <NonFunctionalPreviewField {...entry} type={type} value={value} rowGuid={rowGuid} />;
};